export default { mobile: '800px' };
